export class PipelineStorageKeys {
  static CREATE_PIPELINE = 'pipeline.general.create.wizard';

  static EDIT_PIPELINE = 'pipeline.general.edit.wizard';
}
